module.exports = __webpack_public_path__ + "images/interview-SAP-2.svg";